import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import {
    MarkovDataset,
    MarkovDatasetCreate,
} from "server/models"
import {
    useInput,
    StateType,
} from "client/utils"
import {
    StoreType,
    MarkovDatasetValidation,
    SaveMarkovDataset,
    setMarkovDatasetEdit,
    setMarkovDatasetReloadList,
    setMarkovDatasetReloadEdit,
    closeModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

interface EditDatasetProps {
    dataset: MarkovDataset
}

let isMounted: boolean

const Form = ({
    dataset,
}: EditDatasetProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(dataset.name)
    const [order, setOrder] = useState(dataset.order)
    const [validation, setValidation] = useState<MarkovDatasetValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (isMounted && modals.length) dispatch(closeModal())
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newDatasetData: MarkovDatasetCreate = {
            modelId: dataset.modelId || model.id,
            name,
            order,
        }

        SaveMarkovDataset(
            dataset.id,
            newDatasetData,
            lang,
        ).then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setMarkovDatasetEdit({
                id: res.newDatasetId || dataset.id,
                ...newDatasetData,
            }))

            dispatch(setMarkovDatasetReloadList(false))
            setTimeout(() => {
                dispatch(setMarkovDatasetReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setMarkovDatasetReloadEdit(false))
                setTimeout(() => {
                    dispatch(setMarkovDatasetReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.order}</Label>
                        <Input
                            type="text"
                            value={order !== null ? order : ""}
                            onChange={(e) => {
                                const parsed = parseInt(e.target.value, 10)
                                if (!Number.isNaN(parsed)) setOrder(parsed)
                                else setOrder(null)
                            }}
                        />
                        <Feedback>{validation && validation.order}</Feedback>
                    </FormGroup>
                </Col>

                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
